import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { installIBoonAI } from './iboonAi';

// Order matters: the design system first, then the shell, so the shell's few
// rules win where they overlap without either needing !important.
import 'iboon-ui/styles.css';
import './shell.css';

// What the iBoon AI button sees of this console (iboonAi.ts).
installIBoonAI();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
